import script from "./Transfer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Transfer.vue?vue&type=script&setup=true&lang=ts"

import "./Transfer.vue?vue&type=style&index=0&id=721e0ea4&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-721e0ea4"]])

export default __exports__